import { Diamond } from '@/entities/Diamond';

interface OpticalField {
  key: string;
  label: string;
  fullLabel: string;
  getFullLabel?: (diamond: Diamond) => string;
  getter: (diamond: Diamond) => Nullable<string>;
  getterValue: (diamond: Diamond) => Nullable<number>;
}

export const FIELD_FIRE: OpticalField = {
  key: 'fire.rg',
  label: 'Fire',
  fullLabel: 'Fire',
  getter: ({ performance }: Diamond) => performance?.fire?.global?.hr ?? null,
  getterValue: ({ performance }: Diamond) => performance?.fire?.global?.mc ?? null,
};

export const FIELD_BRILLIANCE: OpticalField = {
  key: 'brightness.rg',
  label: 'Brilliance',
  fullLabel: 'Brilliance',
  getter: ({ performance }: Diamond) => performance?.brilliance?.global?.hr ?? null,
  getterValue: ({ performance }: Diamond) => performance?.brilliance?.global?.mc ?? null,
};

export const FIELD_SHAPE_NORMALIZED_PERFORMANCE: OpticalField = {
  key: 'shapeNormalizedPerformance',
  label: 'Shape Norm. Perf.',
  fullLabel: 'Shape Normalized Performance',
  getFullLabel: ({ performance }: Diamond) => (performance?.integralV2?.shape?.hr ? 'Shape Normalized Performance v2 (Beta)' : 'Shape Normalized Performance'),
  getter: ({ performance }: Diamond) => performance?.integralV2?.shape?.hr ?? performance?.integral?.shape?.hr ?? null,
  getterValue: ({ performance }: Diamond) => performance?.integralV2?.shape?.mc ?? performance?.integral?.shape?.mc ?? null,
};

export const FIELD_GLOBAL_PERFORMANCE: OpticalField = {
  key: 'integral.val',
  label: 'Global Perf.',
  fullLabel: 'Global Performance',
  getFullLabel: ({ performance }: Diamond) => (performance?.integralV2?.global?.hr ? 'Global Performance v2 (Beta)' : 'Global Performance'),
  getter: ({ performance }: Diamond) => performance?.integralV2?.global?.hr ?? performance?.integral?.global?.hr ?? null,
  getterValue: ({ performance }: Diamond) => performance?.integralV2?.global?.mc ?? performance?.integral?.global?.mc ?? null,
};

export const OPTICAL_FIELDS = [FIELD_FIRE, FIELD_BRILLIANCE, FIELD_SHAPE_NORMALIZED_PERFORMANCE, FIELD_GLOBAL_PERFORMANCE];
